module.exports = __webpack_public_path__ + "static/media/shuttle-van.0c716286.svg";